import React, { Component } from 'react';
import MalidCard from './MalidCard';

class BinView extends Component {
	render() {
		return (
			<MalidCard title={window.l('bin_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('bin_about')}
				database="bin_malid2">
				{
					this.props.data && this.props.data.map((item, index) => {
						return item.flettur.map((fletta, flettaIndex) => <p className="card-text" key={`${index}-${fletta.id || flettaIndex}`}><a href={'http://bin.arnastofnun.is/leit/?id='+fletta.id} target="_blank">{item.lemma}</a> {fletta.kennimyndir && fletta.kennimyndir.length > 0 ? fletta.kennimyndir+', ' : ''}<span dangerouslySetInnerHTML={{__html: fletta.ofl}} /></p>)
					})
				}
			</MalidCard>
		);
	}
}

export default BinView;



// WEBPACK FOOTER //
// ./src/components/BinViewV2.js